import styled from 'styled-components';
import Colors from 'assets/Colors';

const ItemWrapper = styled.div`
  display: flex;
  padding: 12px;
  cursor: pointer;
  ${(props) =>
    (props.last ? '' : `border-bottom: 1px solid ${Colors.line_separator};`)}
  font-weight: 500;
`;

export default { ItemWrapper };
